<template>
  <div>
    <div class="header">
      <span></span>
      <div>{{ classInfos.course_name }}</div>
      <!-- <div>{{classInfos}}</div> -->
    </div>
    <el-card class="box-card" shadow="never">
      <div class="card_header flex">
        <div class="card_one flex" style="margin-right: 79px">
          <img src="../../../assets/app_img/icon_class.png" alt="" />
          <span>{{ classInfos.name }}</span>
        </div>
        <div class="card_one flex">
          <span style="margin-right: 20px">{{ classInfos.unique_code }} </span>
          <button class="copy-btn" v-clipboard:copy="unique_code" v-clipboard:success="onCopy" v-clipboard:error="onError"
            style="margin-right: 20px;background:#DA6013">复制</button>
          <img @click="openQR" src="../../../assets/app_img/icon_code.png" alt="" />
        </div>
      </div>
      <div class="teacher">
        <div style="font-weight: 600;">老师</div>
        <div class="phoneImg">
          <div class="phoneImg teacherList" v-for="(item, index) in classInfos.teachers" :key="index">
            <img :src="item.photo" alt="" />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="student">
        <div style="font-weight: 600;">学生</div>
        <div class="phoneImg">
          <div class="phoneImg teacherList" v-for="(item, index) in classInfos.students" :key="index">
            <img :src="item.photo" alt="" />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </el-card>
    <!-- <Vds></Vds> -->
    <!-- 二维码弹框 -->
    <ClassQR ref="class_qr" :qr_code="qr_code"></ClassQR>
  </div>
</template>

<script>
import ClassQR from './addClassQr'
import Clipboard from 'clipboard'
import { mapState } from 'vuex'
// import Vds from '../../../components/video/index.vue'
export default {
  components: { ClassQR, Clipboard },
  data () {
    return {
      text: this.unique_code,
      classInfo: {},
      students: [],
      teachers: [],
      qr_code: "",
      unique_code: '',
      class_name: '',
    }
  },
  created () {
    this.classData()
    this.QRcode()
  },
  mounted () { },
  updated () {
  },
  computed: {
    ...mapState({
      lesson: state => state.lesson,
      cate: state => state.cate,
      classInfos: state => state.classInfo
    })
  },
  methods: {
    onCopy (e) {
      this.$message.success("内容已复制到剪切板！")
    },
    // 复制失败时的回调函数
    onError (e) {
      this.$message.error("抱歉，复制失败！")
    },
    async QRcode () {
      const res = await this.$axios.post("/base/class/qrcode", {
        class_id: window.localStorage.getItem("class_id"),
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.qr_code = res.data.data.qrcode_url
      }
    },
    async classData () {
      const res = await this.$axios.post("/base/class/info", {
        class_id: window.localStorage.getItem("class_id"),
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.teachers = res.data.data.teachers
        this.students = res.data.data.students
        this.class_name = res.data.data.name
        this.unique_code = res.data.data.unique_code
      }
    },
    openQR () {
      this.$refs.class_qr.dialogVisible = true
    },
  },
  watch: {
    unique_code: {
      handler (newData, oldData) {
        this.unique_code = newData
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  min-height: 645px;
}

button {
  padding: 5px 14px;
  background: #e6a23c;
  color: #fff;
  // border-color: #e6a23c;
  border: none;
  border-radius: 2px;
}

button:hover {
  cursor: pointer;
}

.flex {
  display: flex;
  // justify-content: center;
  align-items: center;
}

.header {
  height: 60px;
  display: flex;
  align-items: center;
  // margin: 37px 0 48px 0;
  // padding: 20px 0 20px 0;
  border-bottom: 1px solid #d8e2eb;
  margin-bottom: 20px;

  img {
    width: 50px;
    height: 50px;
  }

  span {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #DA6013;
    border-radius: 50%;
    margin-right: 8px;
  }

  div {
    font-family: Microsoft YaHei;
    font-size: 16px;
    // font-weight: bolder;
    color: #1b2422;
    font-weight: 600;
  }
}

.box-card {
  color: #1b2422;

  // font-weight: bold;
  img {
    display: block;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    margin-right: 12px;
  }

  .phoneImg {
    display: flex;
    justify-items: center;
    justify-content: start;
    align-items: center;
    flex-flow: row wrap;
    margin-right: 30px;
  }

  .teacher {
    margin-left: 50px;

    .teacherList {
      margin-right: 40px;
    }

    margin-bottom: 32px;

    >div {
      margin-bottom: 24px;
    }
  }

  .student {
    margin-left: 50px;

    >div {
      margin-bottom: 24px;
    }
  }

  .card_header {
    border-bottom: 1px solid #eff5f8;
    margin-bottom: 24px;
    padding: 28px 0;

    img {
      width: 28px;
      height: 30px;
      border-radius: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/banji/index.vue